import { useEffect, useRef, useState } from "react";
import NewWindow from "react-new-window";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import moment from "moment";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import Download from "@mui/icons-material/Download";

import {
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";

import "react-quill/dist/quill.snow.css";
import "./EditTicket.css";
import Loader from "./Loader";
import TicketFieldsForm from "./TicketFieldsForm";
import MessageList from "../Chat/MessageList";
// import ModalHistory from "../Chat/ModalHistory";
import NewChat from "../Chat/NewChat";
import KnowledgeBase1 from "../Documents/Knowledge-Base-1.pdf";
import KnowledgeBase2 from "../Documents/Knowledge-Base-2.pdf";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import QAForm from "../QA/QAForm";

import {
  getRecordingFiles,
  getScreenRecording,
  setMakeCall,
} from "../Store/Actions/CallAction";

import {
  getTicket,
  getCustomControlTicket,
  getCustomInput,
  getHistoryTicket,
  getAttachmentTicket,
  updateTicket,
  upload,
  getResponseTemplateList,
  getChannelList,
  getAgentFilter,
  assignTicketCoordinator,
  createBulkEditTicket,
} from "../Store/Actions/TicketAction";

import { GET_CONTACT_DETAILS } from "../Store/Types/ContactTypes";
import { SET_SELECTED_TICKET_CASE_ID } from "../Store/Types/TicketTypes";
import TicketEscalationDialog from "../Ticket/TicketEscalationDialog";
import { stateAction } from "../Store/Actions/AuthAction";
import { RESET_CALL_STATE, SET_GO_TO_ACW } from "../Store/Types/CallTypes";
import MessageListIG from "../Chat/MessageListIG";

const apiUrl = process.env.REACT_APP_FILE_SERVER_URL;

const EditTicket = ({
  caseID,
  isBulkEditing,
  listBulkEditTicketID,
  setIsEditing,
  setTicketAction,
  setContactID,
  setIsContactDetailsModalShown,
  setSelectedTicket,
  setTicketMergeSource,
  handleCloseBulkEdit,
  handlePrev,
}) => {
  // const [openModal, setOpenModal] = useState(false);
  const [isChatDialogShown, setIsChatDialogShown] = useState(false);
  const [ticketData, setTicketData] = useState({});
  const [QAData, setQAData] = useState({});
  const [currentView, setCurrentView] = useState("form");
  const [customInput, setCustomInput] = useState([]);
  const [isCustomInputLoading, setIsCustomInputLoading] = useState(true);
  const [responseTemplateList, setResponseTemplateList] = useState([]);

  const [isResponseTemplateListLoading, setIsResponseTemplateListLoading] =
    useState(true);

  const [responseTemplate, setResponseTemplate] = useState("");
  const [isDescriptionEmpty, setIsDescriptionEmpty] = useState(false);
  const [isAttachmentTooLarge, setIsAttachmentTooLarge] = useState(false);
  const [isRecordingLoading, setIsRecordingLoading] = useState(false);

  const [isScreenRecordingLoading, setIsScreenRecordingLoading] =
    useState(false);

  const [isRecordingPlaying, setIsRecordingPlaying] = useState(false);
  const [isSeekVoiceAllowed, setIsSeekVoiceAllowed] = useState(null);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [selectedScreenRecording, setSelectedScreenRecording] = useState(null);
  const [anchorElKnowledgeBase, setAnchorElKnowledgeBase] = useState(null);
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null);
  const [isRecordingWindowOpen, setIsRecordingWindowOpen] = useState(false);

  const [isScreenRecordingWindowOpen, setIsScreenRecordingWindowOpen] =
    useState(false);

  const dispatch = useDispatch();

  const { agentPermission, CurrentState, myInfo } = useSelector(
    (state) => state.auth
  );

  const { isInACW, stateCall } = useSelector((state) => state.call);

  const initialData = {
    // Commented keys might be used later
    caseid: caseID,
    createddate: "",
    statusid: "",
    department: "",
    departmentid: "",
    categoryid: "",
    typeid: "",
    subtypeid: "",
    subsubtypeid: "",
    userid: "",
    title: "",
    description: "",
    lastupdateby: myInfo.user.AgentID,
    resolution: "",
    contactid: "",
    reminder: "",
    ticketno: "",
    phoneno: "",
    email: "",
    assignto: "",
    priorityid: "",
    // productid: '',
    // hduserid: '',
    messageid: stateCall.RecFileName ? stateCall.RecFileName : null,
    attachment: [],
    casecontrolvalue: [],
    issendcsat: false,
    isfirstload: false, // Used when updating "new" ticket to "in progress"
    reqescalate: false, // Used when escalating ticket
    remark: "", // Internal notes
    calltype: stateCall.CallType ? stateCall.CallType : null,
    isfrontlinernoteditable: null // To disable fields when editing ticket as front liner
  };

  const [formData, setFormData] = useState(initialData);
  const [isHistoryLoading, setIsHistoryLoading] = useState(true);
  const [historyChatId, setHistoryChatId] = useState([]);
  const [history, setHistory] = useState([]);
  const [attachmentHistory, setAttachmentHistory] = useState([]);
  const [attachmentToUpload, setAttachmentToUpload] = useState({});
  const [isQAFormDialogShown, setIsQAFormDialogShown] = useState(false);

  const [isTicketEscalationDialogShown, setIsTicketEscalationDialogShown] =
    useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [channelList, setChannelList] = useState([]);
  const [isMergedTicket, setIsMergedTicket] = useState(false);
  const [isTicketFieldsLoading, setIsTicketFieldsLoading] = useState(true);
  const [subordinateList, setSubordinateList] = useState([]);
  const [isFollowUpDialogShown, setIsFollowUpDialogShown] = useState(false);
  const [isFollowUpCallDialogShown, setIsFollowUpCallDialogShown] =
    useState(false);
  const recordingRef = useRef(null);
  const { width } = useWindowDimensions();
  const currentPage = localStorage.getItem("winPage");
  const openKnowledgeBaseMenu = Boolean(anchorElKnowledgeBase);

  // Add noopener noreferrer rel tag for target attributes
  DOMPurify.addHook("afterSanitizeAttributes", function (node) {
    // Check if the node has a target attribute
    if ("target" in node) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });

  const truncateFromLast = (str) => {
    /* if (str.length > 200) {
      return "..." + str.slice(-197);
    } else { */
      return str;
    // }
  };

  // Modules and formats for React Quill component
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  useEffect(() => {
    fetchTicketData();

    /*
      Get list of subordinate agents for follow up.
      Only called for leaders/supervisors
    */
    if (myInfo.user.Level > 0) {
      getAgentFilter(myInfo.user.AgentID)
        .then((response) => {
          if (response.status) {
            console.log("subordinates data", response.data);
            setSubordinateList(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [caseID]);

  useEffect(() => {
    setIsHistoryLoading(true);

    getHistoryTicket(caseID)
      .then((response) => {
        if (response.status) {
          console.log("History data", response.data[0]);
          setHistory(response.data[0]);
          setIsHistoryLoading(false);
        } else {
          console.log("error", response.error);
          setIsHistoryLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsHistoryLoading(false);
      });

    getAttachmentTicket(caseID)
      .then((response) => {
        if (response.status) {
          console.log("Attachment data", response.data[0]);
          setAttachmentHistory(response.data[0]);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    getChannelList()
      .then((response) => {
        if (response.status) {
          console.log("phoneTypeList", response.data);
          setChannelList(response.data);
        } else {
          console.log("error", response.error);
          toast.error("Error fetching phone type list", { autoClose: 3000 });
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error fetching phone type list", { autoClose: 3000 });
      });
  }, [caseID, isTicketEscalationDialogShown]);

  // Get seek voice permission
  useEffect(() => {
    const seekVoicePermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.SeekVoice"
    );

    if (seekVoicePermission && seekVoicePermission.PermissionAccess === "A") {
      setIsSeekVoiceAllowed(true);
    } else {
      setIsSeekVoiceAllowed(false);
    }
  }, [agentPermission]);

  // Event listener for audio `ended` event
  useEffect(() => {
    recordingRef.current &&
      recordingRef.current.addEventListener("ended", () =>
        setIsRecordingPlaying(false)
      );

    return () => {
      recordingRef.current &&
        recordingRef.current.removeEventListener("ended", () =>
          setIsRecordingPlaying(false)
        );
    };
  }, [recordingRef.current]);

  const fetchResponseTemplateList = (channelID) => {
    setIsResponseTemplateListLoading(true);

    // Get response template list
    getResponseTemplateList(channelID)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Response template list: ", response.data);

          setResponseTemplateList(response.data);
          setIsResponseTemplateListLoading(false);
        } else {
          console.log("error", response.error);
          setIsResponseTemplateListLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsResponseTemplateListLoading(false);
      });
  };

  function fetchTicketData() {
    /*
      Get ticket data and custom input values.
      Get ticket data first, if success, call getCustomControlTicket to get custom input values.
      Then set the formData
    */
    getTicket(caseID, isMergedTicket)
      .then((response) => {
        if (response.status) {
          let ticketData = response.data.case.data[0];
          console.log("Ticket data", ticketData);
          setTicketData(ticketData);
          response.data.casescorelog &&
            setQAData(
              response.data.casescorelog[response.data.casescorelog.length - 1]
            );

          getCustomControlTicket(caseID)
            .then((response) => {
              if (response.status) {
                console.log("Custom field data", response.data[0]);
                let customFieldData = response.data[0];

                const newFormData = {
                  ...formData,
                  createddate: ticketData.CreatedDate,
                  ticketno: ticketData.TicketNo,
                  phoneno: ticketData.PhoneNo,
                  email: ticketData.Email,
                  contactid: ticketData.ContactID,

                  // Change status to in progress if ticket status is new and agent opens this ticket
                  statusid: ticketData.StatusID === 2 ? 3 : ticketData.StatusID,

                  department: ticketData.Department,
                  departmentid: ticketData.DepartmentID,
                  assignto: ticketData.AssignedTo ? ticketData.AssignedTo : "",
                  priorityid: ticketData.PriorityID,
                  typeid: ticketData.TypeID,
                  subtypeid: ticketData.SubTypeID,
                  subsubtypeid: ticketData.SubSubTypeID,
                  resolution: ticketData.Resolution,
                  title: ticketData.Title,
                  userid: ticketData.UserID,
                  reminder: ticketData.SLA,
                  issendcsat: ticketData.IsSendCSAT ?? false,
                  isfrontlinernoteditable: ticketData.IsFrontlinerNotEditable,

                  casecontrolvalue: customFieldData.map((item) => {
                    return {
                      controlname: item.ControlName,
                      value: item.Value,
                    };
                  }),
                };

                // Update ticket if ticket status is new and agent opens this ticket
                if (ticketData.StatusID === 2) {
                  updateTicket({
                    ...newFormData,
                    contactid: 0,
                    description: "Ticket in Progress!",
                    isfirstload: true,
                  })
                    .then((response) => {
                      if (response.status) {
                        setIsHistoryLoading(true);

                        console.log(
                          "Output historyID",
                          response.data.historyid
                        );

                        // Refetch ticket history
                        getHistoryTicket(caseID)
                          .then((response) => {
                            if (response.status) {
                              console.log("History data", response.data[0]);
                              setHistory(response.data[0]);
                              setIsHistoryLoading(false);
                            } else {
                              console.log("error", response.error);
                              setIsHistoryLoading(false);
                            }
                          })
                          .catch((err) => {
                            console.log("err", err);
                            setIsHistoryLoading(false);
                          });
                      } else {
                        console.log("error", response.error);

                        toast.error(`Error Updating Ticket! ${response?.error}`, {
                          autoClose: 3000,
                        });
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);

                      toast.error(`Error Updating Ticket! ${err}`, {
                        autoClose: 3000,
                      });
                    });
                }

                setFormData(newFormData);
              } else {
                console.log("error", response.error);
              }
            })
            .catch((err) => console.log("err", err));

          setIsCustomInputLoading(true);

          // Get custom fields
          getCustomInput(ticketData.SubSubTypeID)
            .then((response) => {
              if (response.status) {
                console.log("Custom input: ", response.data);
                setCustomInput(response.data);
                setIsCustomInputLoading(false);
              } else {
                console.log("error", response.error);
                setIsCustomInputLoading(false);
              }
            })
            .catch((err) => {
              console.log("err", err);
              setIsCustomInputLoading(false);
            });

          fetchResponseTemplateList(ticketData.ContactID);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }

  // HTML decoder for whatsapp messages
  const decodeHTML = (input) => {
    let e = document.createElement("div");
    e.innerHTML = input;

    return new DOMParser().parseFromString(input, "text/html").documentElement
      .textContent;
  };

  const renderHistoryIcon = (contactID, description) => {
    let backgroundColor;
    let icon;

    switch (contactID) {
      case 0:
        backgroundColor =
          description.includes("Ticket Merged") ||
          description.includes("Merge Ticket") ||
          description.includes("Follow up")
            ? "#0343C7"
            : description.includes("Assigned to") ||
              description.includes("Escalated to")
            ? "#F97427"
            : "#727272";

        icon = "material-symbols:deployed-code-outline-sharp";
        break;

      case 1:
        backgroundColor = "#BA68C8";
        icon = "ic:baseline-local-phone";
        break;

      case 2:
        backgroundColor = "#FF9800";
        icon = "material-symbols:mail-rounded";
        break;

      case 3:
        backgroundColor = "#ffe900";
        icon = "ic:round-edit-note";
        break;

      case 5:
        backgroundColor = "#3F80FF";
        icon = "ph:chat-dots-fill";
        break;

      case 9:
        backgroundColor = "#4CAF50";
        icon = "ic:baseline-whatsapp";
        break;

      case 18:
        backgroundColor = "#FFA500";
        icon = "fluent:video-person-call-24-filled";
        break;

      default:
        break;
    }

    return (
      <div className="item-icon" style={{ backgroundColor: backgroundColor }}>
        <Icon height="24" icon={icon} width="24" />
      </div>
    );
  };

  const handleClose = () => {
    // To refetch contact ticket log data
    dispatch({ type: GET_CONTACT_DETAILS });

    // Reset selected ticket
    dispatch({
      type: SET_SELECTED_TICKET_CASE_ID,
      payload: null,
    });

    setFormData(initialData);
    setIsEditing && setIsEditing(false);
    setTicketAction && setTicketAction("");
    setContactID && setContactID(null);
    setIsMergedTicket(false);
  };

  const handleSelectedModalHistory = (props) => {
    setHistoryChatId(props);
    // setOpenModal(true);
    setIsChatDialogShown(true);
  };

  const handleSubmit = () => {
    const updateDepartment = (showToast) => {
      updateTicket({
        ...formData,
        contactid: 0,
        description: `<p>Ticket Assigned to Department <strong>${formData.department}</strong>!</p>`,
      })
        .then((response) => {
          if (response.status) {
            console.log("Output historyID", response.data.historyid);

            if (showToast) {
              toast.success("Ticket updated successfully", {
                autoClose: 3000,
              });
            }
          } else {
            console.log("error", response.error);

            toast.error(`Error Updating Ticket! ${response?.error}`, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("err", err);

          toast.error(`Error Updating Ticket! ${err}`, {
            autoClose: 3000,
          });
        });
    };

    const closeTicket = () => {
      updateTicket({
        ...formData,
        attachment: [],
        contactid: 0,
        description: "Ticket Closed!",
      })
        .then((response) => {
          if (response.status) {
            console.log("Output historyID", response.data.historyid);

            handleClose();
          } else {
            console.log("error", response.error);

            toast.error(`Error Updating Ticket! ${response?.error}`, {
              autoClose: 3000,
            });

            handleClose();
          }
        })
        .catch((err) => {
          console.log("err", err);

          toast.error(`Error Updating Ticket! ${err}`, {
            autoClose: 3000,
          });

          handleClose();
        });
    };

    const handleUpdateTicket = () => {
      // Only update department if department changed and both description and remark is empty
      if (
        formData.departmentid !== ticketData.DepartmentID &&
        (!formData.description.length ||
          formData.description === "<p><br></p>") &&
        (!formData.remark.length || formData.remark === "<p><br></p>")
      ) {
        updateDepartment(true);
      } else {
        updateTicket(formData)
          .then((response) => {
            if (response.status) {
              console.log("Output historyID", response.data.historyid);

              toast.success("Ticket updated successfully", {
                autoClose: 3000,
              });

              setIsSubmitting(false);

              // If department is changed, update description as system
              if (formData.departmentid !== ticketData.DepartmentID) {
                updateDepartment();
              }

              // If ticket is newly closed, update description as system
              if (
                formData.statusid !== ticketData.StatusID &&
                formData.statusid === 1
              ) {
                closeTicket();
              } else {
                handleClose();
              }
            } else {
              console.log("error", response.error);

              toast.error(`Error Updating Ticket! ${response?.error}`, {
                autoClose: 3000,
              });

              setIsSubmitting(false);
              handleClose();
            }
          })
          .catch((err) => {
            console.log("err", err);

            toast.error(`Error Updating Ticket! ${err}`, {
              autoClose: 3000,
            });

            setIsSubmitting(false);
            handleClose();
          });
      }
    };

    const handleBulkEditTicket = () => {
      createBulkEditTicket({
        actionby: myInfo.user.AgentID,
        statusid: formData.statusid,
        resolution: formData.resolution,
        description: formData.description,
        contactid: formData.contactid,
        issendcsat: formData.issendcsat,
        attachment: formData.attachment,
        remark: formData.remark,

        ticket: listBulkEditTicketID.map((ticketID) => ({
          ticketid: ticketID,
        })),
      })
        .then((response) => {
          if (response.status) {
            toast.success("Tickets updated successfully", {
              autoClose: 3000,
            });

            setIsSubmitting(false);
            handleCloseBulkEdit();
          } else {
            console.log("error", response.error);
            toast.error("Error updating tickets", { autoClose: 3000 });
            setIsSubmitting(false);
            handleCloseBulkEdit();
          }
        })
        .catch((err) => {
          console.log("err", err);
          toast.error("Error updating tickets", { autoClose: 3000 });
          setIsSubmitting(false);
          handleCloseBulkEdit();
        });
    };

    if (Object.keys(attachmentToUpload).length > 0) {
      upload({ data: attachmentToUpload })
        .then((response) => {
          if (response.status) {
            console.log("Upload success");
            console.log("form data: ", formData);
            isBulkEditing ? handleBulkEditTicket() : handleUpdateTicket();
          } else {
            console.log("error", response.error);
            toast.error("Error uploading attachment", { autoClose: 3000 });
            isBulkEditing ? handleCloseBulkEdit() : handleClose();
          }
        })
        .catch((err) => {
          console.log("err", err);
          toast.error("Error uploading attachment", { autoClose: 3000 });
          isBulkEditing ? handleCloseBulkEdit() : handleClose();
        });
    } else {
      isBulkEditing ? handleBulkEditTicket() : handleUpdateTicket();
    }

    dispatch({ type: SET_GO_TO_ACW, payload: false });

    // End call if in ACW
    if (isInACW) {
      dispatch({ type: RESET_CALL_STATE });
      dispatch(stateAction("READY", undefined, "ACW", "Green"));
    }

    // To refetch contact ticket log data
    dispatch({ type: GET_CONTACT_DETAILS });

    isBulkEditing ? handleCloseBulkEdit() : handleClose();
  };

  const setHeaderColor = (contactID) => {
    let color;

    switch (contactID) {
      case 1:
        color = "#BA68C8";
        break;

      case 2:
        color = "#FF9800";
        break;

      case 5:
        color = "#3F80FF";
        break;

      case 7:
        color = "#3F80FF";
        break;

      case 8:
        color = "#BA68C8";
        break;

      case 9:
      case 10:
        color = "#4CAF50";
        break;

      default:
        color = "#727272";
        break;
    }

    return color;
  };

  const ChannelType = ({ value, history }) => {
    console.log("channeltype:", value, history);
    switch (value) {
      case 5: //LiveChat
        return (
          <button
            className="action-button"
            style={{ backgroundColor: "#FF9800" }}
            onClick={() => handleSelectedModalHistory(history.FK_ChatListID)}
            type="button"
          >
            Show Chat
          </button>
        );
      case 7: //FB
        return (
          <button
            className="action-button"
            style={{ backgroundColor: "#3F80FF" }}
            onClick={() => handleSelectedModalHistory(history.FK_ChatListID)}
            type="button"
          >
            Show Chat
          </button>
        );
      case 8: //IG
        return (
          <button
            className="action-button"
            style={{ backgroundColor: "#BA68C8" }}
            onClick={() => handleSelectedModalHistory(history.FK_ChatListID)}
            type="button"
          >
            Show Chat
          </button>
        );
      case 9: //WA
        return (
          <button
            className="action-button"
            style={{ backgroundColor: "#4CAF50" }}
            onClick={() => handleSelectedModalHistory(history.caseID)}
            type="button"
          >
            Show Chat
          </button>
        );
      case 10: //WABA
        return (
          <button
            className="action-button"
            style={{ backgroundColor: "#4CAF50" }}
            onClick={() => handleSelectedModalHistory(history.FK_ChatListID)}
            type="button"
          >
            Show Chat
          </button>
        );
      default:
        break;
    }
  };

  const updateTicketFollowUp = () => {
    updateTicket({
      ...formData,
      contactid: 0,
      description: "Follow up initiated",
    })
      .then((response) => {
        if (response.status) {
          console.log("Output historyID", response.data.historyid);
          setIsHistoryLoading(true);

          // Refetch ticket history
          getHistoryTicket(caseID)
            .then((response) => {
              if (response.status) {
                console.log("History data", response.data[0]);
                setHistory(response.data[0]);
                setIsHistoryLoading(false);
              } else {
                console.log("error", response.error);
                setIsHistoryLoading(false);
              }
            })
            .catch((err) => {
              console.log("err", err);
              setIsHistoryLoading(false);
            });
        } else {
          console.log("error", response.error);

          toast.error(`Error Updating Ticket! ${response?.error}`, {
            autoClose: 3000,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);

        toast.error(`Error Updating Ticket! ${err}`, {
          autoClose: 3000,
        });
      });
  };

  return (
    <div className="edit-ticket">
      {/* {console.log("kondisi", openModal)} */}

      <Dialog
        open={isChatDialogShown}
        className="dialog chat-dialog"
        fullWidth
        maxWidth="md"
        scroll="paper"
        onClose={() => setIsChatDialogShown(false)}
      >
        <div className="dialog-container">
          <div className="dialog-content">
            <header>
              <IconButton
                className="close-button"
                onClick={() => setIsChatDialogShown(false)}
              >
                <CloseOutlined />
              </IconButton>
            </header>

            <div className="message-list-container">
              {ticketData.ContactID === 8 ? (
                <MessageListIG chatListID={historyChatId} />
              ) : (
                <MessageList
                  chatListID={historyChatId}
                  isLiveChat={ticketData.ContactID === 5}
                />
              )}
            </div>
          </div>
        </div>
      </Dialog>

      {/* {openModal && historyChatId > 0 ? (
        <ModalHistory
          onClose={() => setOpenModal(false)}
          ChatListID={historyChatId}
        />
      ) : (
        ""
      )} */}

      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();

          // If department is not changed, check if the description is empty
          if (
            (!formData.description.length ||
              formData.description === "<p><br></p>") &&
            // (formData.departmentid === ticketData.DepartmentID) &&
            (!formData.remark.length || formData.remark === "<p><br></p>")
          ) {
            setIsDescriptionEmpty(true);
          } else if (
            // Attachment size validation. Show error if attached file size exceeds 25 MB
            formData.attachment.some(
              (attachment) => attachment.bodylength >= 26214400
            )
          ) {
            setIsAttachmentTooLarge(true);
          } else {
            setIsDescriptionEmpty(false);
            setIsAttachmentTooLarge(false);
            handleSubmit();
          }
        }}
      >
        <div
          className="ticket-no"
          style={{ backgroundColor: setHeaderColor(ticketData.ContactID) }}
        >
          <Icon icon="fa:ticket" width="26" height="26" />

          <p title={ticketData?.Title ? ticketData.Title : "Untitled Ticket"}>
            {ticketData?.Title ? ticketData.Title : "Untitled Ticket"}
            {isMergedTicket ? " (Merged Ticket)" : ""}
          </p>

          <Tooltip title="Close" arrow>
            <IconButton className="close-button" onClick={handleClose}>
              <Icon icon="iconamoon:close" width="28" height="28" />
            </IconButton>
          </Tooltip>
        </div>

        <div className="button-container">
          {width >= 1200 && currentPage !== "contact" && (
            <>
              <Tooltip title="View contact" arrow placement="left">
                <IconButton
                  className="view-contact-button"
                  style={{ backgroundColor: "#0343c7" }}
                  onClick={() => {
                    setContactID(ticketData.CustomerID);
                    setIsContactDetailsModalShown(true);
                  }}
                >
                  <Icon height="26" icon="material-symbols:person" />
                </IconButton>
              </Tooltip>

              {ticketData.IsAssignCoordinator && (
                <Tooltip title="Assign this ticket to me" arrow placement="left">
                  <IconButton
                    style={{ backgroundColor: "#0343c7" }}
                    onClick={() => {
                      assignTicketCoordinator({ ticketid: caseID })
                        .then((response) => {
                          if (response.status) {
                            toast.success(
                              "This ticket is now assigned to you",
                              {
                                autoClose: 3000,
                              },
                            );

                            fetchTicketData();
                          } else {
                            console.log("error", response.error);

                            toast.error("Error assigning ticket", {
                              autoClose: 3000,
                            });
                          }
                        })
                        .catch((err) => {
                          console.log("err", err);

                          toast.error("Error assigning ticket", {
                            autoClose: 3000,
                          });
                        });
                    }}
                  >
                    <Icon color="#fff" height="26" icon="material-symbols:task-rounded" />
                  </IconButton>
                </Tooltip>
              )}

              <Tooltip title="Merge ticket" arrow placement="left">
                <IconButton
                  className="merge-ticket-button"
                  style={{ backgroundColor: "#0343c7" }}
                  onClick={() => {
                    handleClose();
                    setTicketMergeSource(ticketData);
                  }}
                >
                  <Icon color="#fff" height="26" icon="bx:link" />
                </IconButton>
              </Tooltip>

              <Tooltip title="View knowledge base" arrow placement="left">
                <IconButton
                  className="view-knowledge-base-button"
                  style={{ backgroundColor: "#0343c7" }}
                  onClick={(event) =>
                    setAnchorElKnowledgeBase(event.currentTarget)
                  }
                >
                  <Icon
                    color="#fff"
                    height="26"
                    icon="material-symbols:quick-reference-outline"
                  />
                </IconButton>
              </Tooltip>

              <Menu
                anchorEl={anchorElKnowledgeBase}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                id="QAMenu"
                open={openKnowledgeBaseMenu}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => setAnchorElKnowledgeBase(null)}
                onClick={() => setAnchorElKnowledgeBase(null)}
              >
                <MenuItem
                  onClick={() => setSelectedKnowledgeBase(KnowledgeBase1)}
                >
                  Knowledge Base 1.pdf
                </MenuItem>

                <MenuItem
                  onClick={() => setSelectedKnowledgeBase(KnowledgeBase2)}
                >
                  Knowledge Base 2.pdf
                </MenuItem>
              </Menu>

              {selectedKnowledgeBase && (
                <NewWindow
                  url={selectedKnowledgeBase}
                  onUnload={() => setSelectedKnowledgeBase(null)}
                />
              )}

              {ticketData.Status !== "Close" && (
                <>
                  {
                    // Only for phone or whatsapp
                    (ticketData.ContactID === 1 ||
                      ticketData.ContactID === 9 ||
                      ticketData.ContactID === 10) &&
                      // Only for the assigned user or the leader of the assigned user
                      (ticketData.UserID === myInfo.user.AgentID ||
                        subordinateList.some(
                          (sub) => sub.AgentName === ticketData.AssignedTo
                        )) && (
                        <Tooltip
                          title="Initiate follow up"
                          arrow
                          placement="left"
                        >
                          <IconButton
                            className="follow-up-button"
                            style={{ backgroundColor: "#0343c7" }}
                            onClick={() => {
                              ticketData.ContactID === 1
                                ? setIsFollowUpCallDialogShown(true)
                                : setIsFollowUpDialogShown(true);
                            }}
                          >
                            <Icon
                              color="#fff"
                              height="26"
                              icon="fa-solid:running"
                            />
                          </IconButton>
                        </Tooltip>
                      )
                  }

                  <Tooltip title="Ticket Escalation" arrow placement="left">
                    <IconButton
                      className="escalation-button"
                      onClick={() => setIsTicketEscalationDialogShown(true)}
                    >
                      <Icon
                        color="#fff"
                        height="26"
                        icon="material-symbols:warning-outline-rounded"
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </>
          )}

          {width >= 1200 && (
            <>
              {ticketData.Status === "Close" && (
                <Tooltip
                  title={QAData ? "View QA Form" : "Fill QA Form"}
                  arrow
                  placement="left"
                >
                  <IconButton
                    className={`qa-button ${QAData ? "view" : "fill"}`}
                    onClick={() => setIsQAFormDialogShown(true)}
                  >
                    <Icon
                      color={QAData ? "#fff" : "#0343c7"}
                      height="26"
                      icon={
                        QAData
                          ? "iconamoon:file-check-light"
                          : "iconamoon:file-close-light"
                      }
                    />
                  </IconButton>
                </Tooltip>
              )}

              {isQAFormDialogShown && (
                <NewWindow
                  copyStyles
                  features={{
                    height: 550,
                    width: width >= 1440 ? 1440 : 900,
                  }}
                  onUnload={() => setIsQAFormDialogShown(false)}
                >
                  <QAForm
                    filledComment={QAData ? QAData.Comment : null}
                    filledTotalScore={QAData ? QAData.TotalScore : null}
                    scoreItemID={QAData ? QAData.ScoreItemID : null}
                    channelID={ticketData ? ticketData.ContactID : null}
                    caseID={caseID}
                    setIsQAFormDialogShown={setIsQAFormDialogShown}
                  />
                </NewWindow>
              )}
            </>
          )}
        </div>

        <header className="mobile-ticket-header">
          <div
            className="toggle-view"
            onClick={() =>
              currentView === "form"
                ? setCurrentView("history")
                : setCurrentView("form")
            }
          >
            <Icon
              height="28"
              icon="material-symbols:swap-horizontal-circle-outline-rounded"
              width="28"
            />

            {currentView === "form" ? "Ticket Field" : "Ticket Detail"}
          </div>

          {width <= 1200 && currentPage !== "contact" && (
            <Tooltip title="View contact" arrow>
              <IconButton
                className="view-contact-button"
                style={{ backgroundColor: "#4CAF50" }}
                onClick={() => {
                  setContactID(ticketData.CustomerID);
                  setIsEditing(false);
                }}
              >
                <Icon icon="material-symbols:person" width="18" height="18" />
              </IconButton>
            </Tooltip>
          )}
        </header>

        <div className="container">
          {(currentView === "form" || width >= 1200) && (
            <section className="form">
              <TicketFieldsForm
                customInput={customInput}
                formData={formData}
                isBulkEditing={isBulkEditing}
                isCustomInputLoading={isCustomInputLoading}
                isMergedTicket={isMergedTicket}
                isTicketFieldsLoading={isTicketFieldsLoading}
                isUpdating
                setCustomInput={setCustomInput}
                setFormData={setFormData}
                setIsCustomInputLoading={setIsCustomInputLoading}
                setIsTicketFieldsLoading={setIsTicketFieldsLoading}
                singleColumn
              />
            </section>
          )}

          {(currentView === "history" || width >= 1200) && (
            <section className="history">
              {isHistoryLoading ? (
                <Loader />
              ) : (
                <div className="container-timeline">
                  <div className="timeline">
                    {history.map((history, index, arr) => {
                      let decodedHTML = decodeHTML(history.Description);

                      return (
                        <>
                          {/* Compare dates, if current message date value is equal as previous message date value, don't show the date component. Except for the first message, which is always shown */}
                          {(!moment
                            .utc(history.TransDate)
                            .isSame(
                              moment.utc(arr[index - 1]?.TransDate),
                              "date"
                            ) ||
                            index === 0) && (
                            <div className="date">
                              {moment
                                .utc(history.TransDate)
                                .format("DD MMM YYYY")}
                            </div>
                          )}

                          <div
                            className="item-container"
                            key={history.HistoryID}
                          >
                            {renderHistoryIcon(
                              history.ContactID,
                              decodedHTML ? decodedHTML : history.Description
                            )}

                            <div className="item">
                              <header>
                                <p className="name">
                                  {history.CustomerName ?? history.AgentName}
                                </p>

                                <div className="right">
                                  {/* Livechat or Whatsapp or WABA */}
                                  {
                                    /* (history.ContactID === 5 ||
                                    history.ContactID === 9 ||
                                    history.ContactID === 10) && ( */

                                    history.ContactID === 5 && (
                                      <button
                                        className="action-button"
                                        style={{ backgroundColor: "#0343c7" }}
                                        onClick={() =>
                                          handleSelectedModalHistory(
                                            history.FK_ChatListID
                                          )
                                        }
                                      >
                                        Show Chat
                                      </button>
                                    )
                                  }

                                  {history.ContactID === 18 &&
                                    history.MessageID && ( // in-app video call
                                      <button
                                        className="action-button"
                                        disabled={isRecordingLoading}
                                        style={{ backgroundColor: "#FFA500" }}
                                        type="button"
                                        onClick={() => {
                                          setIsScreenRecordingLoading(true);
                                          setIsScreenRecordingWindowOpen(true); // Open window before API call

                                          const fileName =
                                            history.MessageID?.split("_").pop();

                                          const uniqueID = fileName?.substring(
                                            0,
                                            fileName.lastIndexOf(".")
                                          );

                                          getScreenRecording(uniqueID)
                                            .then((response) => {
                                              if (response.status) {
                                                setSelectedScreenRecording(
                                                  response.data
                                                );

                                                setIsScreenRecordingLoading(
                                                  false
                                                );
                                              } else {
                                                console.log(
                                                  "error",
                                                  response.error
                                                );

                                                toast.error(
                                                  "Error loading screen recording: " +
                                                    response.error,

                                                  { autoClose: 3000 }
                                                );

                                                setIsScreenRecordingLoading(
                                                  false
                                                );
                                                setIsScreenRecordingWindowOpen(
                                                  false
                                                );
                                              }
                                            })
                                            .catch((err) => {
                                              console.log("err", err);

                                              toast.error(
                                                "Error loading screen recording: " +
                                                  err,

                                                { autoClose: 3000 }
                                              );

                                              setIsScreenRecordingLoading(
                                                false
                                              );
                                              setIsScreenRecordingWindowOpen(
                                                false
                                              );
                                            });
                                        }}
                                      >
                                        {isScreenRecordingLoading
                                          ? "Loading..."
                                          : "Show Screen Recording"}
                                      </button>
                                    )}

                                  {history.MessageID &&
                                    history.ContactID !== 18 &&
                                    history.ContactID !== 3 && (
                                      // For calls, to play recording
                                      <button
                                        className="action-button"
                                        disabled={isRecordingLoading}
                                        style={{ backgroundColor: "#BA68C8" }}
                                        type="button"
                                        onClick={() => {
                                          setIsRecordingLoading(true);
                                          setIsRecordingWindowOpen(true); // Open window before API call

                                          getRecordingFiles(history.MessageID)
                                            .then((response) => {
                                              if (response.status) {
                                                setSelectedRecording(
                                                  response.data
                                                );

                                                recordingRef.current =
                                                  new Audio(
                                                    `data:audio/wav;base64,${response.data.filebytes}`
                                                  );

                                                setIsRecordingLoading(false);
                                              } else {
                                                console.log(
                                                  "error",
                                                  response.error
                                                );

                                                toast.error(response.error);
                                                setIsRecordingLoading(false);
                                                setIsRecordingWindowOpen(false); // Close on error
                                              }
                                            })
                                            .catch((err) => {
                                              console.log("err", err);
                                              toast.error(err);
                                              setIsRecordingLoading(false);
                                              setIsRecordingWindowOpen(false); // Close on error
                                            });
                                        }}
                                      >
                                        {isRecordingLoading
                                          ? "Loading..."
                                          : "Show Recording"}
                                      </button>
                                    )}

                                  {(history.Description.includes(
                                    "Ticket Merged"
                                  ) ||
                                    history.Description.includes(
                                      "Merge Ticket"
                                    )) && ( // Only show for merged ticket
                                    <button
                                      className="action-button"
                                      style={{ backgroundColor: "#0343C7" }}
                                      type="button"
                                      onClick={() => {
                                        setIsMergedTicket(true);
                                        setSelectedTicket(history.RefCaseID);
                                      }}
                                    >
                                      Show Ticket
                                    </button>
                                  )}

                                  <div className="time">
                                    <Icon
                                      icon="mingcute:time-line"
                                      width="18"
                                      height="18"
                                    />

                                    <p>
                                      {moment
                                        .utc(history.TransDate)
                                        .format("HH:mm")}
                                    </p>
                                  </div>
                                </div>
                              </header>

                              <p
                                className="message"
                                dangerouslySetInnerHTML={{
                                  // Sanitize HTML to increase security against XSS attacks
                                  __html: DOMPurify.sanitize(
                                    history.ContactID === 9 && decodedHTML
                                      ? truncateFromLast(decodedHTML)
                                      : truncateFromLast(history.Description),
                                    {
                                      USE_PROFILES: { html: true },
                                      ADD_ATTR: ["target"],
                                    }
                                  ),
                                }}
                              />

                              {attachmentHistory.find(
                                (file) => file.HistoryID === history.HistoryID
                              ) && (
                                <div className="attachments">
                                  <p>Attachments:</p>

                                  <div className="file-list">
                                    {attachmentHistory
                                      .filter(
                                        (file) =>
                                          file.HistoryID === history.HistoryID
                                      )
                                      .map((filteredFile) => {
                                        return (
                                          <div className="file">
                                            <a
                                              download
                                              href={
                                                history.ContactID === 2 &&
                                                history.CustomerID != null
                                                  ? `${apiUrl}/email/${filteredFile.FileName}`
                                                  : `${apiUrl}/ticket/${filteredFile.Name}`
                                              }
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              <IconButton>
                                                <Icon
                                                  height="18"
                                                  icon="ic:baseline-download"
                                                  width="18"
                                                />
                                              </IconButton>
                                            </a>

                                            <p>{filteredFile.Name}</p>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              )}

                              {history.DepartmentHistory && (
                                <p className="department-name">
                                  {history.DepartmentHistory}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      );
                    })}

                    <div className="item-container">
                      <div
                        className="item-icon"
                        style={{ backgroundColor: "#727272" }}
                      >
                        <Icon
                          height="24"
                          icon="icon-park-outline:stopwatch-start"
                          width="24"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="response">
                <TextField
                  className="show-in-bulk-edit"
                  fullWidth
                  label="Contact With"
                  name="contactWith"
                  select
                  value={formData.contactid}
                  onChange={(e) => {
                    fetchResponseTemplateList(e.target.value);

                    setFormData({
                      ...formData,
                      contactid: e.target.value,
                    });
                  }}
                >
                  {channelList.map((channel) => (
                    <MenuItem value={channel.ChannelID}>
                      {channel.Description}
                    </MenuItem>
                  ))}
                </TextField>

                {isResponseTemplateListLoading ? (
                  <Loader />
                ) : (
                  <TextField
                    // displayEmpty
                    fullWidth
                    label="Response Template"
                    name="responseTemplate"
                    select
                    value={responseTemplate}
                    onChange={(e) => {
                      setResponseTemplate(e.target.value);

                      setFormData({
                        ...formData,
                        description: responseTemplateList.find(
                          (item) => item.TemplateID === e.target.value
                        )?.Description,
                      });
                    }}
                  >
                    {responseTemplateList.length > 0 ? (
                      responseTemplateList.map((item) => (
                        <MenuItem value={item.TemplateID}>{item.Name}</MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No response template found</MenuItem>
                    )}
                  </TextField>
                )}

                {isDescriptionEmpty && (
                  <div className="required-message">
                    <Icon
                      color="#ffb529"
                      icon="ion:warning"
                      width="20"
                      height="20"
                    />
                    <p>Please fill out this field.</p>
                  </div>
                )}

                <ReactQuill
                  className={isDescriptionEmpty ? "error" : "show-in-bulk-edit"}
                  formats={formats}
                  modules={modules}
                  placeholder="Description *"
                  theme="snow"
                  value={formData.description}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      description: e,
                    });

                    setIsDescriptionEmpty(false);
                  }}
                />

                <ReactQuill
                  className="show-in-bulk-edit"
                  formats={formats}
                  modules={modules}
                  placeholder="Internal Notes"
                  theme="snow"
                  value={formData.remark}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      remark: e,
                    });
  
                    setIsDescriptionEmpty(false);
                  }}
                />

                {isAttachmentTooLarge && (
                  <div className="required-message">
                    <Icon
                      color="#ffb529"
                      icon="ion:warning"
                      width="20"
                      height="20"
                    />
                    <p>Attachment file size cannot exceed 25 MB!</p>
                  </div>
                )}

                <TextField
                  className="input-attachment"
                  error={isAttachmentTooLarge}
                  fullWidth
                  label="Attachments"
                  type="file"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ multiple: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon icon="mdi:attachment-vertical" width="26" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={async (e) => {
                    const filesToUpload = []; // For upload API, includes base64 string
                    const filesToAttach = []; // For insertticket API, without base64
                    setIsAttachmentTooLarge(false);

                    try {
                      for (let i = 0; i < e.target.files.length; i++) {
                        const file = e.target.files[i];
                        const reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = () => {
                          filesToUpload.push({
                            name: file.name,
                            filename: file.name,
                            contenttype: file.type,
                            file: reader.result,
                          });

                          filesToAttach.push({
                            name: file.name,
                            filename: file.name,
                            contenttype: file.type,
                            bodylength: file.size,
                          });
                        };
                      }
                    } catch (error) {
                      console.log("error upload: ", error);
                    }

                    setFormData({
                      ...formData,
                      attachment: filesToAttach,
                    });

                    setAttachmentToUpload(filesToUpload);
                  }}
                />
              </div>
            </section>
          )}
        </div>

        <section className="buttons">
          <div className="container">
            <button
              className="cancel"
              type="button"
              onClick={isBulkEditing ? handlePrev : handleClose}
            >
              {isBulkEditing ? "Prev" : "Cancel"}
            </button>

            <button
              className="confirm"
              disabled={
                isSubmitting || isAttachmentTooLarge || isDescriptionEmpty
                // || (ticketData.UserID && ticketData.UserID !== myInfo.user.AgentID)
              }
              type="submit"
            >
              {isSubmitting && <CircularProgress className="progress" />}
              Submit
            </button>
          </div>
        </section>
      </form>

      {isRecordingWindowOpen && (
        <NewWindow
          features={{
            height: 200,
            width: 400,
          }}
          onUnload={() => {
            setSelectedRecording(null);
            setIsRecordingWindowOpen(false);
          }}
        >
          {selectedRecording ? (
            <div
              className={`controls new-window ${
                !isSeekVoiceAllowed ? "simple" : ""
              }`}
            >
              {isSeekVoiceAllowed ? (
                // Audio with controls if seek voice is allowed
                <audio
                  controls
                  controlsList="nodownload"
                  src={
                    selectedRecording
                      ? `data:audio/wav;base64,${selectedRecording?.filebytes}`
                      : ""
                  }
                />
              ) : (
                // Play/pause button if seek voice is not allowed
                <Button
                  className="download-button"
                  disabled={!selectedRecording || isRecordingLoading}
                  variant="contained"
                  onClick={() => {
                    if (isRecordingPlaying) {
                      recordingRef.current.pause();
                      setIsRecordingPlaying(false);
                    } else {
                      recordingRef.current.play();
                      setIsRecordingPlaying(true);
                    }
                  }}
                >
                  {isRecordingLoading ? (
                    <Icon height="24" icon="eos-icons:loading" />
                  ) : isRecordingPlaying ? (
                    <Icon height="24" icon="ic:round-pause" />
                  ) : (
                    <Icon height="24" icon="ph:play-fill" />
                  )}
                </Button>
              )}

              {selectedRecording && (
                <a
                  download={selectedRecording?.filename}
                  href={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
                >
                  <Button variant="contained" className="download-button">
                    <Download />
                  </Button>
                </a>
              )}
            </div>
          ) : (
            <Loader />
          )}
        </NewWindow>
      )}

      {isScreenRecordingWindowOpen && (
        <NewWindow
          features={{
            height: 480,
            width: 640,
          }}
          onUnload={() => {
            setSelectedScreenRecording(null);
            setIsScreenRecordingWindowOpen(false);
          }}
        >
          {selectedScreenRecording ? (
            <div className="screen-recording-container">
              <video controls>
                <source
                  src={`${process.env.REACT_APP_FILE_SERVER_URL}/screen-recording/${selectedScreenRecording}`}
                  type="video/webm"
                />
              </video>

              <a
                download={selectedScreenRecording}
                href={`${process.env.REACT_APP_API_URL}call/downloadscreenrecording/${selectedScreenRecording}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <IconButton>
                  <Icon
                    color="#fff"
                    height="18"
                    icon="bxs:download"
                    width="18"
                  />
                </IconButton>
              </a>
            </div>
          ) : (
            <Loader />
          )}
        </NewWindow>
      )}

      {isTicketEscalationDialogShown && (
        <TicketEscalationDialog
          caseID={caseID}
          formData={formData}
          handleCloseTicket={handleClose}
          isOpen={isTicketEscalationDialogShown}
          setIsTicketEscalationDialogShown={setIsTicketEscalationDialogShown}
        />
      )}

      {isFollowUpDialogShown && (
        <NewChat
          isFollowUp
          parentMsgParam={{ number: ticketData.PhoneNo }}
          setOpenModal={setIsFollowUpDialogShown}
          updateTicket={updateTicketFollowUp}
        />
      )}

      <Dialog
        open={isFollowUpCallDialogShown}
        className="dialog follow-up-call-dialog"
        fullWidth
        maxWidth="sm"
        scroll="paper"
        onClose={handleClose}
      >
        <header>
          <Icon height="28" icon="ion:warning" width="28" />
          <p>Warning!</p>
          <Icon height="28" icon="ion:warning" width="28" />
        </header>

        <div className="dialog-content">
          <p>Initiate follow up call to ({ticketData.PhoneNo}) ?</p>

          <div className="buttons">
            <Button
              className="cancel"
              variant="outlined"
              onClick={() => setIsFollowUpCallDialogShown(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                dispatch(
                  setMakeCall({
                    phoneNo: ticketData.PhoneNo,
                    agentStatus: CurrentState,
                    // goToACW: data.CampaignID ? true : false,
                    contactID: ticketData.ContactID,
                  })
                );

                setIsFollowUpCallDialogShown(false);
                updateTicketFollowUp();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EditTicket;
